<!-- <app-header></app-header> -->
<div *ngIf="showLoader" class="loader">
    <img src="assets/svg/preloader.svg" alt="">
</div>
<div class="container-fluid no-padding root-body-display">
    <router-outlet>
        <!-- <div class="loader" *ngIf="showLoader">
            <div class="spinner">
                <div class="spinner-border text-primary large-spinner" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div> -->
    </router-outlet>
</div>

<div class="mobile">
    <div class="mobile-image">
        <img src="assets/svg/mobile_view_no_support.svg">
    </div>
    <div class="content">
        <p class="font-weight-bold">Mobile view currently not supported.</p>
        <p>Please switch back to desktop view.</p>
    </div>
</div>

<ng-container>
    <!-- Floating Button -->
    <button 
        class="floating-button" 
        [class.display-none]="!isLoggedIn() || !iframeEndpoint.includes('dashboard/chat/liveChat/')"
        (click)="onButtonClick($event)" 
        (mousedown)="startDragging($event)">
        <img src="assets/svg/tru.ai.group.svg" alt="Open Tru.ai" class="floating-button-icon">
    </button>

    <!-- Sidepanel -->
    <div 
        class="sidepanel-overlay" 
        *ngIf="showSidepanel" 
        (click)="closeSidepanel()">
    </div>

    <div 
        class="sidepanel" 
        [ngClass]="{'show': showSidepanel, 'maximized': isMaximized}">
        <div class="sidepanel-header">
            <div class="sidepanel-controls">
                <button 
                    class="control-button" 
                    *ngIf="!isMaximized" 
                    (click)="maximizeSidepanel()">
                    <i class="fa fa-expand"></i>
                </button>
                <button 
                    class="control-button" 
                    *ngIf="isMaximized" 
                    (click)="minimizeSidepanel()">
                    <i class="fa fa-compress"></i>
                </button>
                <button 
                    class="control-button close-button" 
                    (click)="closeSidepanel()">
                    <i class="fa fa-times"></i>
                </button>
            </div>
        </div>
        <div class="sidepanel-content">
            <ng-container *ngIf="showSidepanel">
                <div class="loader screen loading-overlay" *ngIf="loading">
                    <img src="assets/svg/preloader.svg" alt="Loading">
                </div>
                <iframe 
                    #iframeRef 
                    class="sidepanel-iframe" 
                    [ngClass]="{'maximized': isMaximized}" 
                    [src]="engageUrl"
                    frameborder="0" 
                    (load)="onIframeLoad(iframeRef)">
                </iframe>
            </ng-container>
        </div>
    </div>
</ng-container>